import React from "react";
import _ from "lodash";
import { Button, Box } from "@showitinc/showit-wc";

import Immutable from "immutable";
import Modal from "../base/Modal";
import ButtonBar from "../base/ButtonBar";
import LinkProperties, { MODE_INLINE } from "../LinkProperties";
import LinkWarning from "./LinkWarning";
import uiPrefix from "../../utils/UiPrefixUtils";

class LinkEntryModal extends React.Component {
  static defaultProps = {
    href: null,
  };

  constructor(props) {
    super(props);

    let linkConfig = LinkEntryModal._initLink(this.props.href);

    this.state = {
      linkConfig: linkConfig,
      prevHref: this.props.href,
    };

    this._cancel = this._cancel.bind(this);
    this._save = this._save.bind(this);
    this._onLinkChange = this._onLinkChange.bind(this);
  }

  static _initLink(href) {
    let linkConfig = null;
    if (!_.isEmpty(href)) {
      try {
        let linkObj = JSON.parse(decodeURI(href));
        if (_.isObject(linkObj)) {
          linkConfig = Immutable.fromJS(linkObj);
        }
      } catch (e) {
        // Something other than an encoded JSON string was in the href
      }
    }

    if (linkConfig == null) {
      linkConfig = Immutable.Map();
    }

    return linkConfig;
  }

  _cancel() {
    this.props.onCancel();
  }

  _save() {
    const linkConfig = this.state.linkConfig;

    if (!linkConfig.isEmpty()) {
      const linkJSON = linkConfig.toJS();
      const linkStr = encodeURI(JSON.stringify(linkJSON));

      this.props.onSave(linkStr);
    } else {
      this.props.onSave();
    }
  }

  _onLinkChange(propInfo, e) {
    this.setState((prevState) => {
      let nameParts = propInfo.name.split(".");
      let linkConfig = prevState.linkConfig;

      if (propInfo.name === "link") {
        linkConfig = propInfo.value == null
          ? linkConfig.clear()
          : linkConfig.mergeIn(nameParts, propInfo.value);
        return { linkConfig };
      }

      const shouldSetValue = _.isNumber(propInfo.value) || (propInfo.value != null && !_.isEmpty(propInfo.value));
      
      if (!shouldSetValue) {
        linkConfig = linkConfig.deleteIn(nameParts);
        return { linkConfig };
      }

      if (nameParts.length < 2) {
        return { linkConfig };
      }

      if (!linkConfig.has("link")) {
        linkConfig = linkConfig.set("link", Immutable.Map());
      }

      linkConfig = linkConfig.updateIn(["link"], (link) => {
        return link
          ? link.set(nameParts[1], propInfo.value)
          : Immutable.Map().set(nameParts[1], propInfo.value);
      });

      return { linkConfig };
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.href !== state.prevHref) {
      const linkConfig = LinkEntryModal._initLink(props.href);
      return { linkConfig, prevHref: props.href };
    }

    return null;
  }

  render() {
    let { linkWarningEnabled } = this.props;
    let link = this.state.linkConfig.get("link");

    let linkWarning = linkWarningEnabled ? <LinkWarning /> : null;

    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Dialog size="small">
          <Modal.Dialog.Header closeButton>
            <Modal.Dialog.Title>Link</Modal.Dialog.Title>
          </Modal.Dialog.Header>
          <Modal.Dialog.Body style={{ overflow: "hidden" }}>
            {linkWarning}
            <LinkProperties mode={MODE_INLINE} link={link} onPropUpdate={this._onLinkChange} />
          </Modal.Dialog.Body>
          <Modal.Dialog.Footer>
            <ButtonBar>
              <Box mr="3">
                <Button
                  variant="minimal"
                  data-e2e={uiPrefix("modal-cancel-btn")}
                  className={uiPrefix("modal-cancel-btn")}
                  onClick={this._cancel}
                >
                  Cancel
                </Button>
              </Box>
              <Button
                variant="feature"
                data-e2e={uiPrefix("modal-save-btn")}
                className={uiPrefix("modal-save-btn")}
                onClick={this._save}
              >
                Save
              </Button>
            </ButtonBar>
          </Modal.Dialog.Footer>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default LinkEntryModal;
